import { Outlet } from 'react-router';

import { EnsureAndroidNavigationBarHidden } from '@sorare/core/src/components/mobileApp/EnsureAndroidNavigationBarHidden';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const SeriesLayout = () => {
  return (
    <RequireAuth>
      <EnsureAndroidNavigationBarHidden />
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesLayout;
